import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'
import { useEvent } from '@hooks/useEvent'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import { updateWorkFlow } from '../../../../commonApis/'
import { ModalLoader } from '@commonComponents/ModalLoader'

const InitiateRFI = (props) => {
    const {
        translate,
        shipId,
        brokerUserGuid
    } = props
    const { saveForm } = useEvent()
    const { updateShipmentId, updateShipmentMode } = useCurrentShipmentType()
    const [isLoading, setLoader] = useState(false)
    const createRFI = async () => {
        setLoader(true)
        const response = await saveForm({
            cloneShipment: {
                cloneStrategy: "CHILD_SHIPMENT"
            }
        }, true, 'CREATE_CLONE_SHIPMENT_NL')
        if (response?.shipmentId) {
            await updateWorkFlow(shipId, "ENTRY_RFI_IN_PROCESS", brokerUserGuid);
            await updateWorkFlow(shipId, "DMS_CRERFI", brokerUserGuid);
            updateShipmentId(response?.shipmentId)
            updateShipmentMode('RFI-1')
        }
        console.log("RFI Cloned shipment response_____", response)
        setLoader(false)
    }
    return (
        <>
            {isLoading && <ModalLoader
                loading={isLoading}
                message='Create RFI in progress...'
            />}
            <Button
                size='mini'
                key='START_JOB_EU'
                disabled={false}
                className='sv todo-button primaryBtn'
                onClick={async (e) => {
                    e.stopPropagation()
                    await createRFI()
                }}
            >
                {translate(`CREATE_RFI`).toUpperCase()}
            </Button>
        </>
    )
}

export default InitiateRFI